import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { useLayoutEffect, useState } from "react"
import { $createMentionNode } from "@editor/nodes/MentionNode"
import { CustomGetUsersOptionLabel, apiClient } from "@dit/core-frontend"
import { API_ENDPOINTS } from "@constants"
import { $createTextNode } from "lexical"

//функция позволяет существенно сократить количество одинаковых запросов
//вызывается только если в тексте редактора присутствует текст вида: @xxx
//то запрашиваем всех пользователей.
//если username такой-же, то создаем mention ноду
const fetchUsersAndCreateMention = async (editor, setUsers, users) => {
  let usersData = users
  try {
    if (!users.length) {
      const { data } = await apiClient.get(API_ENDPOINTS.users, {
        params: {
          epp: 1000,
        },
      })
      setUsers(data.data.itemsList)
      usersData = data.data.itemsList
    }
    const usernamesSet = new Set(usersData.map((user) => user.username))
    //крайне важно заново сформировать filteredNodeMap  т.к содержимое редактора могло измениться
    const nodeMap = editor?._editorState?._nodeMap ? [...editor._editorState._nodeMap] : []
    const filteredNodeMap = nodeMap.filter(
      ([key, value]) => value.__type === "text" && value.__text.includes("@"),
    )
    const newFilteredNodeMap = filteredNodeMap.filter(([key, value]) => {
      const match = value.__text.match(/@(\S+)/)
      return match && usernamesSet.has(match[1])
    })

    newFilteredNodeMap.map(([key, value]) => {
      const stringParse = value.__text?.split(" ")
      editor.update(
        () => {
          const nodes = []
          stringParse.map((item) => {
            if (item.startsWith("@")) {
              const userData = usersData.find((user) => user.username === item.substring(1))
              if (userData?.id) {
                const textNode = $createTextNode(" ")
                const mentionNode = $createMentionNode(
                  "@",
                  `@ ${CustomGetUsersOptionLabel(userData)}`,
                  {
                    trigger: "@",
                    value: userData.username,
                    displayValue: `${CustomGetUsersOptionLabel(userData)}`,
                    data: userData,
                  },
                )
                nodes.push(mentionNode, textNode)
              } else {
                const textNode = $createTextNode(`⠀${item}`)
                nodes.push(textNode)
              }
            } else {
              const textNode = $createTextNode(`${item}`)
              nodes.push(textNode)
            }
            return undefined
          })
          const parent = value.getParent()
          value.remove()

          parent.append(...(nodes || nodes))
          parent.selectEnd()
        },
        { tag: "historic" },
      )

      return undefined
    })
  } catch (err) {
    console.error(err)
  }
}

export function OnChangePlugin({
  ignoreHistoryMergeTagChange = true,
  ignoreSelectionChange = false,
  onChange,
}) {
  const [users, setUsers] = useState([])
  const [editor] = useLexicalComposerContext()

  useLayoutEffect(() => {
    if (onChange) {
      return editor.registerUpdateListener(
        ({ editorState, dirtyElements, dirtyLeaves, prevEditorState, tags }) => {
          if (
            (ignoreSelectionChange && dirtyElements.size === 0 && dirtyLeaves.size === 0) ||
            (ignoreHistoryMergeTagChange && tags.has("history-merge")) ||
            prevEditorState.isEmpty()
          ) {
            return
          }

          const nodeMap = editor?._editorState?._nodeMap ? [...editor._editorState._nodeMap] : []
          const filteredNodeMap = nodeMap.filter(
            ([key, value]) => value.__type === "text" && value.__text.includes("@"),
          )
          if (filteredNodeMap?.length) {
            fetchUsersAndCreateMention(editor, setUsers, users)
          }

          onChange(editorState, editor, tags)
        },
      )
    }
  }, [editor, ignoreHistoryMergeTagChange, ignoreSelectionChange, onChange])

  return null
}
